import React from "react";

export default class RedirectComponent extends React.Component {
  componentDidMount() {
    const obj = new URL(window.config.apiRoot);
    const loginUrl = `${window.location.protocol}//${obj.host}/login`;
    window.location.replace(loginUrl);
  }

  render() {
    return null;
  }
}
